import { render, staticRenderFns } from "./ProductFooter.vue?vue&type=template&id=cf0cddf0&scoped=true&"
import script from "./ProductFooter.vue?vue&type=script&lang=ts&"
export * from "./ProductFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFooter.vue?vue&type=style&index=0&id=cf0cddf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0cddf0",
  null
  
)

export default component.exports